"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitFunction = exports.ConnectWithData = void 0;
// ---------- import Packs
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
// ---------- import Internals
const setData_1 = require("./functions/setData");
const initCentralData_1 = require("./initCentralData");
// ---------- set Default Function
const ConnectWithData = initData => ({ children }) => {
    const initFn = () => (0, setData_1.setData)(() => [{ path: '/', val: initData }]);
    // ---------- set Return
    return (react_1.default.createElement(react_redux_1.Provider, { store: initCentralData_1.initCentralData },
        react_1.default.createElement(exports.InitFunction, { setFunction: initFn }, children)));
};
exports.ConnectWithData = ConnectWithData;
const InitFunction = ({ children, setFunction }) => {
    // ----------- set Hooks
    const [sttCondShow, setCondChildren] = react_1.default.useState(false);
    // ----------- set Effects
    const fxInitData = () => {
        setFunction();
        setCondChildren(true);
    };
    react_1.default.useEffect(fxInitData, []);
    // ----------- set Return
    return react_1.default.createElement(react_1.default.Fragment, null, sttCondShow && children);
};
exports.InitFunction = InitFunction;
